import findClosestFocusTarget from './find-closest-focus-target'

export default findClosestFocusTarget
